import {
  Group as RACGroup,
  type GroupProps as RACGroupProps,
  Input as RACInput,
  type InputProps as RACInputProps,
  Label as RACLabel,
  type LabelProps as RACLabelProps,
  NumberField as RACNumberField,
  type NumberFieldProps as RACNumberFieldProps,
} from "react-aria-components";

export interface NumberFieldProps extends RACNumberFieldProps {}
export interface NumberFieldLabelProps extends RACLabelProps {}
export interface NumberFieldGroupProps extends RACGroupProps {}
export interface NumberFieldInputProps extends RACInputProps {}

export function NumberField(props: NumberFieldProps) {
  return <RACNumberField {...props} />;
}

export function NumberFieldLabel(props: NumberFieldLabelProps) {
  return <RACLabel {...props} />;
}

export function NumberFieldGroup(props: NumberFieldGroupProps) {
  return <RACGroup {...props} />;
}

export function NumberFieldInput(props: NumberFieldInputProps) {
  return <RACInput {...props} />;
}
